import { useVideoConversion } from "@/components/media-viewer/hooks/useVideoConversion";

import type { PostVideoSource } from "../scheduledPost";

// Muted autoplay so it plays inline like a feed would, without controls covering the platform overlay.
export function PostVideo({
  className,
  title,
  video,
}: {
  className?: string;
  title: string;
  video: PostVideoSource;
}) {
  const needsConversion = video.extension.toLowerCase() === "mov";
  const { convertedUrl, status } = useVideoConversion(
    video.attachmentId,
    needsConversion,
  );
  const src = needsConversion ? convertedUrl : video.url;

  if (!src) {
    return (
      <div
        className={`flex items-center justify-center bg-bg-secondary p-lg text-center text-sm text-text-tertiary ${className ?? ""}`}
      >
        {status === "unavailable"
          ? "Video preview isn't available"
          : "Preparing video…"}
      </div>
    );
  }

  return (
    <video
      aria-label={`Post video for ${title}`}
      autoPlay
      className={className}
      key={src}
      loop
      muted
      playsInline
      src={src}
    />
  );
}
